export default __webpack_public_path__ + "images/youtube.4f602b1f9625dbf3a6ad64ff2b91b3e0.svg";